module.exports = __webpack_public_path__ + "static/media/apple-flat.262487d5.png";